import {
  WSButton,
  WSButtons,
  WSForm,
  WSRadioInputGroup,
  WSText
} from "@wingspanhq/fe-component-library";
import { CalculationSettings1099Toggle } from "@wingspanhq/payments/dist/interfaces";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { SetupFlowRouteComponentProps } from "../../components/SetupFlow/SetupFlow";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import { useUserId } from "../../query/hooks/helpers";
import { useUpdatePayrollSettings } from "../../query/payments/mutations";
import { useUpdateActivity } from "../../query/users/mutations";
import { useActivities } from "../../query/users/queries";
import { get1099SetupProgress } from "../../query/users/selectors";
import { ErrorContextKey } from "../../services/platform";
import { NEC1099FilingContainer } from "../components/NEC1099FilingContainer";
import styles from "./styles.module.scss";

export const OffPlatformPaymentsQuestion: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const history = useHistory();
  const userId = useUserId();
  const qActivity = useActivities(userId);
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const [
    updatePayrollSettings,
    updatePayrollSettingsMeta
  ] = useUpdatePayrollSettings(userId);
  const [hasOffPlatformPayments, setHasOffPlatformPayments] = useState();

  const onFormSubmit = async () => {
    await updatePayrollSettings(
      {
        calculationSettings1099: {
          offPlatformPayments: hasOffPlatformPayments
        }
      },
      {
        onSuccess: async () => {
          if (
            hasOffPlatformPayments === CalculationSettings1099Toggle.Exclude
          ) {
            const nec1099SetupProgress = get1099SetupProgress(qActivity.data);
            await updateActivity({
              flows: {
                nec1099Setup: {
                  ...nec1099SetupProgress,
                  currentStep: 4
                }
              }
            });
          }

          onNext({
            shouldImportOffPlatformPayments:
              hasOffPlatformPayments === CalculationSettings1099Toggle.Include
          });
        }
      }
    );
  };
  return (
    <NEC1099FilingContainer title="Off-platform payments">
      <WSText.Heading2 mb="L">
        Have you made any payments made outside of Wingspan that you have not
        imported yet?
      </WSText.Heading2>
      <WSText.Paragraph color="grey700" mb="M">
        Wingspan can include non-employee compensation from payments made
        outside of Wingspan. We will help you upload these prior payments as
        payables.
      </WSText.Paragraph>
      <WSText.Paragraph color="grey700" mb="M">
        Have you made any off-platform payments you would like to include in
        this year's 1099-NEC filing? We will help you import these as payables.
      </WSText.Paragraph>

      <WSForm onSubmit={onFormSubmit}>
        <WSRadioInputGroup
          mb="XL"
          name="hasOffPlatformPayments"
          onChange={(event: any) => {
            setHasOffPlatformPayments(event.target?.value);
          }}
          options={[
            {
              value: CalculationSettings1099Toggle.Include,
              label: "Yes, import payments made outside of Wingspan"
            },
            {
              value: CalculationSettings1099Toggle.Exclude,
              label: "No, include payments made via Wingspan"
            }
          ]}
          optionHasBorder
          value={hasOffPlatformPayments}
        />

        <WSErrorMessage
          mt="M"
          contextKey={ErrorContextKey.PayrollSettings}
          error={updatePayrollSettingsMeta.error}
        />
        <WSButtons mt="XL">
          <WSButton.Secondary className={styles.actionBtn} onClick={onBack}>
            Back
          </WSButton.Secondary>
          <WSForm.SubmitButton
            className={styles.actionBtn}
            data-testid="hasOffPlatformPayments"
            disabled={!hasOffPlatformPayments}
            loading={
              updateActivityMeta.isLoading ||
              updatePayrollSettingsMeta.isLoading
            }
          >
            Continue
          </WSForm.SubmitButton>
        </WSButtons>
      </WSForm>
    </NEC1099FilingContainer>
  );
};
